<template>
  <section class="container-fluid">
    <div class="row">
      <div class="col-12" v-if="$can('read_all-users')">
        <b-col class="px-0">
          <search-by-skill></search-by-skill>
        </b-col>
      </div>
    </div>
  </section>
</template>

<script>
import SearchBySkill from './SearchBySkill'
export default {
  name: 'home',
  components: { SearchBySkill },
  data () {
    return {

    }
  },
  methods: {},
  created () {

  },
  mounted () {}
}
</script>

<style scoped>
</style>
